import React, { Component } from "react";
import classnames from "classnames";

import { Button } from "./Button";
import * as styles from "./ContentTabsButton.scss";

export interface IContentTabsButtonProps {
    index: number;
    name: string;
    active: boolean;
    onActivateTab: (index: number) => void;
}

export class ContentTabsButton extends Component<IContentTabsButtonProps> {
    public render() {
        const { name, active } = this.props;

        return (
            <Button
                className={classnames(
                    styles["content-tabs-button"],
                    styles.button,
                    active && styles.active,
                )}
                onClicked={this.onActivateTab}
            >
                {name}
            </Button>
        );
    }

    private onActivateTab = () => {
        this.props.onActivateTab(this.props.index);
    };
}
